import React from 'react'
import Visibility from '@react/react-spectrum/Icon/Visibility'
import VisibilityOff from '@react/react-spectrum/Icon/VisibilityOff'

export default function LayerVisibility ({
    layer
}) {
    return layer.visible ? <Visibility size="S" /> : <VisibilityOff size="S" />
}
